import { ActionReducerMap } from '@ngrx/store';
import { AuthState, authReducer } from './auth/auth.reducer';
import { UiState, uiReducer } from './ui/ui.reducer';
import { CatalogState, catalogReducer } from './catalog/catalog.reducer';
import { CatalogEffects } from './catalog/catalog.effects';

export interface AppState {
  auth: AuthState;
  ui: UiState;
  catalog: CatalogState;
}

export const appReducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  ui: uiReducer,
  catalog: catalogReducer,
};

export const appEffects = [CatalogEffects];
